// import React from 'react';
// import { Link } from 'react-router-dom';
// // import './Home.css';

// const Home = () => {
//   return (
//     <main className="home">
//       {/* Hero Section */}
//       <section className="hero">
//         <img 
//           src="/images/company-banner.jpg" 
//           alt="Company Banner" 
//           className="hero-image" 
//         />
//       </section>

//       {/* Clickable Image Grid Section */}
//       <section className="image-grid">
//         <Link to="/advanced-machinery" className="image-card">
//           <img 
//             src="/images/machine.jpg" 
//             alt="Advanced Machineries" 
//           />
//           <p>Advanced Machineries</p>
//         </Link>
//         <Link to="/about" className="image-card">
//           <img 
//             src="/images/factory.jpg" 
//             alt="Our Factory" 
//           />
//           <p>State-of-the-Art Facilities</p>
//         </Link>
//         <Link to="/categories" className="image-card">
//           <img 
//             src="/images/team.jpg" 
//             alt="Expert Team" 
//           />
//           <p>Expert Engineering Team</p>
//         </Link>
//       </section>
//     </main>
//   );
// };

// export default Home;
// 

import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <main className="home">
      {/* Hero Section */}
      <section className="hero">
        <img 
          src="/images/company-banner.jpg" 
          alt="Company Banner" 
          className="hero-image" 
        />
      </section>

      {/* Introduction Section */}
      <section className="intro-section">
        <h2>Welcome to Our Industry</h2>
        <p>Explore our cutting-edge technologies and meet the experts behind them.</p>
      </section>

      {/* Image Grid Section */}
      <section className="image-grid">
        <div className="image-row">
          <Link to="/advanced-machinery" className="image-card">
            <img src="/images/machine.jpg" alt="Advanced Machineries" />
            <p>Advanced Machineries</p>
          </Link>
          <Link to="about" className="image-card">
            <img src="/images/factory.jpg" alt="Our Factory" />
            <p>State-of-the-Art Facilities</p>
          </Link>
          <Link to="services" className="image-card">
            <img src="/images/team.jpg" alt="Expert Team" />
            <p>Expert Engineering Team</p>
          </Link>
        </div>
      </section>
    </main>
  );
};

export default Home;
